import { useState, useEffect, useContext } from "react";
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from "../context/AuthContext";


function SearchGroupUpdates() {
    const { card_number } = useParams()
    const { account } = useContext(AuthContext)
    const [card, setCard] = useState(null);
    const [originalGroups, setOriginalGroups] = useState([])
    const [currentGroups, setCurrentGroups] = useState([])
    const [sortedGroups, setSortedGroups] = useState({
        damage: [],
        cardGain: [],
        playerBuff: [],
        playerDebuff: [],
        target: [],
        cardChange: [],
        deckChange: [],
        boardChange: [],
        playerAction: [],
        activationTiming: [],
        resolution: [],
        effectType: [],
        cost: [],
        support: [],
        antiSupport: [],
        miscellaneous: []
    })
    const [noSearchGroups, setNoSearchGroups] = useState(true)

    const getCard = async() =>{
        // const cardData = cards.find(card => card.card_number.toString() === card_number)
        const cardResponse = await fetch(`https://pm-deck-react-only.onrender.com/cards/${card_number}`)
        if (cardResponse.ok) {
            const cardData = await cardResponse.json()
            cardData["seriesNames"] = cardData.series_name.split("//")
            cardData["effectText"] = cardData.effect_text.split("//")
            if (cardData.second_effect_text){
                cardData["secondEffectText"] = cardData.second_effect_text.split("//")
            }
            setCard(cardData);
        }
    };

    const getGroupCategories = async() => {
        const groupsResponse = await fetch("https://pm-deck-react-only.onrender.com/search_groups/")
        const groupsData = await groupsResponse.json()
        if (groupsData.length > 0) {
            const searchGroups = groupsData.sort((a,b) => a.name.localeCompare(b.name))
            setOriginalGroups(searchGroups.filter(group => group.members.includes(parseInt(card_number, 10))))
            setCurrentGroups(searchGroups.filter(group => group.members.includes(parseInt(card_number, 10))))
            let categories = {
                damage: [],
                cardGain: [],
                playerBuff: [],
                playerDebuff: [],
                target: [],
                cardChange: [],
                deckChange: [],
                boardChange: [],
                playerAction: [],
                activationTiming: [],
                resolution: [],
                effectType: [],
                cost: [],
                support: [],
                antiSupport: [],
                miscellaneous: []
            }
            for (let group of searchGroups) {
                const category = group.groupCategory
                categories[category].push(group);
            }
            setSortedGroups(categories)
            setNoSearchGroups(false)
        }
    }


    useEffect(() => {
        window.scroll(0, 0);
        getCard()
        getGroupCategories()
        document.title = "Search Groups - CW CardBase"
        return () => {
            document.title = "ComboWeaver CardBase"
        };
        // eslint-disable-next-line
    },[]);

    const addGroup = (group) => {
        if (!currentGroups.find(g => g.id === group.id)) {
            setCurrentGroups((prevGroups) => [...prevGroups, group])
        }
    }

    const removeGroup = (group) => {
        setCurrentGroups((prevGroups) => prevGroups.filter(g => g.id !== group.id))
    }

    const resetGroups = () => {
        setCurrentGroups(originalGroups)
    }

    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        const currentidList = currentGroups.map(group => group.id);
        const originalList = originalGroups.map(group => group.id);
        const groupsToAdd = currentidList.filter(id => !originalList.includes(id));
        const groupsToRemove = originalList.filter(id => !currentidList.includes(id));

        const updateData = {
            addIds: groupsToAdd,
            removeIds: groupsToRemove,
            cardNumber: parseInt(card_number, 10)
        }

        console.log(updateData)
        const groupUrl = "https://pm-deck-react-only.onrender.com/search_groups/update_groups";
        // const groupUrl = "http://localhost:4000/search_groups/update_groups";
        const fetchConfig = {
            method: "POST",
            body: JSON.stringify(updateData),
            headers: {
                "Content-Type": "application/json",
            },
        };

        const response = await fetch(groupUrl, fetchConfig);
        if (response.ok) {
            const responseData = await response.json();
            console.log("Success", responseData)
            navigate(`/cards/${card_number}`)
        } else {
            alert("Error in creating group");
        }
    }

    if (!(account && account.roles.includes("admin"))) {
        setTimeout(function() {
            window.location.href = `${process.env.PUBLIC_URL}/`
        }, 3000);
    }

    return (
        <div className="white-space">
            <h1 className="left-h1-2">Search Groups</h1>
            {card ?
                <div className={card.card_class ? `big${card.card_class}5` : "bigNoClass2"} style={{marginBottom: "20px"}}>
                    <h3 style={{fontWeight: "600", margin: "12px"}}>{card.name}</h3>
                    <h5 style={{fontWeight: "600", margin: "12px"}}>{card.card_class} {card.cardType}</h5>
                    {card.effectText.map((line) =>
                    <h6 style={{fontWeight: "400", margin: "3px 12px"}}>
                        {line}</h6>)}
                    {card.secondEffectText?
                    <>{card.secondEffectText.map((line) =>
                    <h6 style={{fontWeight: "400", margin: "12px 12px 3px 12px"}}>
                        {line}</h6>)}</>
                    :null}
                    <h5 style={{fontWeight: "600", margin: "12px 12px 0px 12px"}}>
                        {card.series_name.replaceAll("//", " | ")} &nbsp; {card.card_number}
                        <span style={{fontSize: "16px"}}>&#11089;</span>
                        {card.hero_id}
                    </h5>
                </div>
            :null}
            { account && account.roles.includes("admin")?
                <>
                    <div>
                        <button
                            className="left margin-left-13 margin-bottom-20"
                            onClick={resetGroups}
                        >
                            Reset
                        </button>
                        <button
                            className="left red margin-bottom-20"
                            onClick={handleSubmit}
                        >
                            Update Groups
                        </button>
                    </div>
                    {sortedGroups?
                    <>
                        <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Current</h3>
                        <div className="card-pool-fill5" style={{marginBottom: "50px"}}>
                        {currentGroups.map((group) =>
                            <h5
                                style={{fontWeight: "400", margin: "5px 12px"}}
                                onClick={() => removeGroup(group)}>
                            {group.name} *</h5>
                            )
                        }
                        </div>
                    </>
                    :null}
                    {!noSearchGroups?
                        <div className="top-bottom-border" style={{marginBottom: "20px", marginTop: "-5px"}}>
                            {sortedGroups && sortedGroups.damage.length > 0?
                                <>
                                    <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Damage</h3>
                                    <div className="card-pool-fill5">
                                        {sortedGroups.damage.map((group) =>
                                            <h5
                                                style={{
                                                        fontWeight: "400",
                                                        margin: "5px 12px",
                                                        backgroundColor: currentGroups.find(g => g.id === group.id) ? "red" : ""
                                                    }}
                                                onClick={() => addGroup(group)}
                                            >
                                            {group.name} *</h5>
                                            )
                                        }
                                    </div>
                                </>
                            :null}
                            {sortedGroups && sortedGroups.cardGain.length > 0?
                                <>
                                    <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Hand/Reserve Change</h3>
                                    <div className="card-pool-fill5">
                                        {sortedGroups.cardGain.map((group) =>
                                            <h5
                                                style={{
                                                        fontWeight: "400",
                                                        margin: "5px 12px",
                                                        backgroundColor: currentGroups.find(g => g.id === group.id) ? "red" : ""
                                                    }}
                                                onClick={() => addGroup(group)}
                                            >
                                            {group.name} *</h5>
                                            )
                                        }
                                    </div>
                                </>
                            :null}
                            {sortedGroups && sortedGroups.playerBuff.length > 0?
                                <>
                                    <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Player/Card Buffs</h3>
                                    <div className="card-pool-fill5">
                                        {sortedGroups.playerBuff.map((group) =>
                                            <h5
                                                style={{
                                                        fontWeight: "400",
                                                        margin: "5px 12px",
                                                        backgroundColor: currentGroups.find(g => g.id === group.id) ? "red" : ""
                                                    }}
                                                onClick={() => addGroup(group)}
                                            >
                                            {group.name} *</h5>
                                            )
                                        }
                                    </div>
                                </>
                            :null}
                            {sortedGroups && sortedGroups.playerDebuff.length > 0?
                                <>
                                    <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Player/Card Debuffs</h3>
                                    <div className="card-pool-fill5">
                                        {sortedGroups.playerDebuff.map((group) =>
                                            <h5
                                                style={{
                                                        fontWeight: "400",
                                                        margin: "5px 12px",
                                                        backgroundColor: currentGroups.find(g => g.id === group.id) ? "red" : ""
                                                    }}
                                                onClick={() => addGroup(group)}
                                            >
                                            {group.name} *</h5>
                                            )
                                        }
                                    </div>
                                </>
                            :null}
                            {sortedGroups && sortedGroups.target.length > 0?
                                <>
                                    <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Target</h3>
                                    <div className="card-pool-fill5">
                                    {sortedGroups.target.map((group) =>
                                            <h5
                                                style={{
                                                        fontWeight: "400",
                                                        margin: "5px 12px",
                                                        backgroundColor: currentGroups.find(g => g.id === group.id) ? "red" : ""
                                                    }}
                                                onClick={() => addGroup(group)}
                                            >
                                            {group.name} *</h5>
                                        )
                                    }
                                    </div>
                                </>
                            :null}
                            {sortedGroups && sortedGroups.cardChange.length > 0?
                                <>
                                    <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Card Change</h3>
                                    <div className="card-pool-fill5">
                                    {sortedGroups.cardChange.map((group) =>
                                            <h5
                                                style={{
                                                        fontWeight: "400",
                                                        margin: "5px 12px",
                                                        backgroundColor: currentGroups.find(g => g.id === group.id) ? "red" : ""
                                                    }}
                                                onClick={() => addGroup(group)}
                                            >
                                            {group.name} *</h5>
                                        )
                                    }
                                    </div>
                                </>
                            :null}
                            {sortedGroups && sortedGroups.deckChange.length > 0?
                                <>
                                    <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Deck Change</h3>
                                    <div className="card-pool-fill5">
                                    {sortedGroups.deckChange.map((group) =>
                                            <h5
                                                style={{
                                                        fontWeight: "400",
                                                        margin: "5px 12px",
                                                        backgroundColor: currentGroups.find(g => g.id === group.id) ? "red" : ""
                                                    }}
                                                onClick={() => addGroup(group)}
                                            >
                                            {group.name} *</h5>
                                        )
                                    }
                                    </div>
                                </>
                            :null}
                            {sortedGroups && sortedGroups.boardChange.length > 0?
                                <>
                                    <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Play-Area Change</h3>
                                    <div className="card-pool-fill5">
                                    {sortedGroups.boardChange.map((group) =>
                                            <h5
                                                style={{
                                                        fontWeight: "400",
                                                        margin: "5px 12px",
                                                        backgroundColor: currentGroups.find(g => g.id === group.id) ? "red" : ""
                                                    }}
                                                onClick={() => addGroup(group)}
                                            >
                                            {group.name} *</h5>
                                        )
                                    }
                                    </div>
                                </>
                            :null}
                            {sortedGroups && sortedGroups.playerAction.length > 0?
                                <>
                                    <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Player Action</h3>
                                    <div className="card-pool-fill5">
                                    {sortedGroups.playerAction.map((group) =>
                                            <h5
                                                style={{
                                                        fontWeight: "400",
                                                        margin: "5px 12px",
                                                        backgroundColor: currentGroups.find(g => g.id === group.id) ? "red" : ""
                                                    }}
                                                onClick={() => addGroup(group)}
                                            >
                                            {group.name} *</h5>
                                        )
                                    }
                                    </div>
                                </>
                            :null}
                            {sortedGroups && sortedGroups.activationTiming.length > 0?
                                <>
                                    <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Activation Timing</h3>
                                    <div className="card-pool-fill5">
                                    {sortedGroups.activationTiming.map((group) =>
                                            <h5
                                                style={{
                                                        fontWeight: "400",
                                                        margin: "5px 12px",
                                                        backgroundColor: currentGroups.find(g => g.id === group.id) ? "red" : ""
                                                    }}
                                                onClick={() => addGroup(group)}
                                            >
                                            {group.name} *</h5>
                                        )
                                    }
                                    </div>
                                </>
                            :null}
                            {sortedGroups && sortedGroups.resolution.length > 0?
                                <>
                                    <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Resolution Effect</h3>
                                    <div className="card-pool-fill5">
                                    {sortedGroups.resolution.map((group) =>
                                            <h5
                                                style={{
                                                        fontWeight: "400",
                                                        margin: "5px 12px",
                                                        backgroundColor: currentGroups.find(g => g.id === group.id) ? "red" : ""
                                                    }}
                                                onClick={() => addGroup(group)}
                                            >
                                            {group.name} *</h5>
                                        )
                                    }
                                    </div>
                                </>
                            :null}
                            {sortedGroups && sortedGroups.effectType.length > 0?
                                <>
                                    <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Effect Type</h3>
                                    <div className="card-pool-fill5">
                                    {sortedGroups.effectType.map((group) =>
                                            <h5
                                                style={{
                                                        fontWeight: "400",
                                                        margin: "5px 12px",
                                                        backgroundColor: currentGroups.find(g => g.id === group.id) ? "red" : ""
                                                    }}
                                                onClick={() => addGroup(group)}
                                            >
                                            {group.name} *</h5>
                                        )
                                    }
                                    </div>
                                </>
                            :null}
                            {sortedGroups && sortedGroups.cost.length > 0?
                                <>
                                    <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Cost</h3>
                                    <div className="card-pool-fill5">
                                    {sortedGroups.cost.map((group) =>
                                            <h5
                                                style={{
                                                        fontWeight: "400",
                                                        margin: "5px 12px",
                                                        backgroundColor: currentGroups.find(g => g.id === group.id) ? "red" : ""
                                                    }}
                                                onClick={() => addGroup(group)}
                                            >
                                            {group.name} *</h5>
                                        )
                                    }
                                    </div>
                                </>
                            :null}
                            {sortedGroups && sortedGroups.support.length > 0?
                                <>
                                    <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Support</h3>
                                    <div className="card-pool-fill5">
                                    {sortedGroups.support.map((group) =>
                                            <h5
                                                style={{
                                                        fontWeight: "400",
                                                        margin: "5px 12px",
                                                        backgroundColor: currentGroups.find(g => g.id === group.id) ? "red" : ""
                                                    }}
                                                onClick={() => addGroup(group)}
                                            >
                                            {group.name} *</h5>
                                        )
                                    }
                                    </div>
                                </>
                            :null}
                            {sortedGroups && sortedGroups.antiSupport.length > 0?
                                <>
                                    <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Anti-Support</h3>
                                    <div className="card-pool-fill5">
                                    {sortedGroups.antiSupport.map((group) =>
                                            <h5
                                                style={{
                                                        fontWeight: "400",
                                                        margin: "5px 12px",
                                                        backgroundColor: currentGroups.find(g => g.id === group.id) ? "red" : ""
                                                    }}
                                                onClick={() => addGroup(group)}
                                            >
                                            {group.name} *</h5>
                                        )
                                    }
                                    </div>
                                </>
                            :null}
                            {sortedGroups && sortedGroups.miscellaneous.length > 0?
                                <>
                                    <h3 style={{fontWeight: "600", margin: "10px 12px"}}>Miscellaneous</h3>
                                    <div className="card-pool-fill5">
                                    {sortedGroups.miscellaneous.map((group) =>
                                            <h5
                                                style={{
                                                        fontWeight: "400",
                                                        margin: "5px 12px",
                                                        backgroundColor: currentGroups.find(g => g.id === group.id) ? "red" : ""
                                                    }}
                                                onClick={() => addGroup(group)}
                                            >
                                            {group.name} *</h5>
                                        )
                                    }
                                    </div>
                                </>
                            :null}
                        </div>
                    :null}
                </>:
                <div className="textwindow">
                    <h1 className="undercontext">This Feature Is For Admins Only</h1>
                    <h3 className="undercontext">Redirecting in 3 Seconds</h3>
                </div>
            }
        </div>
    );
}

export default SearchGroupUpdates;
